<template>
  <button
    class="btn btn-xs btn-danger"
    type="button"
    @click="confirmEndTestDrive"
  >
    End
  </button>
</template>

<script>
import { mapState } from "vuex";
import swal from "sweetalert2";
import store from "../../store/stores";

export default {
  name: "EndTestDriveButton",
  store,
  props: {
    subscriberId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState(["testdrive"]),
  },
  methods: {
    endTestDrive(event, subscriberId = this.subscriberId) {
      return this.$store.dispatch("testdrive/endTestDrive", subscriberId);
    },
    confirmEndTestDrive(event) {
      swal
        .fire({
          title: "Just checking...",
          type: "question",
          html: `
          <div style="font-size: small">
          <p style="margin: auto">Are you sure you would like to end this Test Drive?</p>
          </div>
        `,
          showCancelButton: true,
          cancelButtonText: "No",
          cancelButtonColor: "rgb(92, 184, 92)",
          confirmButtonText: "Yes",
          confirmButtonColor: "rgb(217, 83, 79)",
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: () => {
            return this.endTestDrive(event);
          },
        })
        .then(function (response) {
          if (response.value.data) {
            if (response.value.data.error) {
              swal.fire({
                title: "Uh oh..",
                type: "error",
                html: `<p style="font-size: small">We were unable to process your request!</p>
                     <p style="font-size: small">${response.value.data.error}</p>`,
              });
            } else {
              swal.fire({
                title: "Success!",
                type: "success",
                html: `<p style="font-size: small">Test Drive ended successful!</p>`,
              });
            }
          } else {
            swal.fire({
              type: "error",
              title: "Uh oh!",
              text: "Something went wrong..",
            });
          }
        });
    },
  },
};
</script>

<style scoped></style>
